import {
  LICENSE,
  VAULT_ACCESS,
  VAULT_OBJECT_TYPE,
  VAULT_TYPE,
  VAULT_UPLOAD_POLICY,
} from "@/types/enums";
import { VaultData, VaultObjectData } from "@/types/data-types";
import HENGE from "@henge-inc/global-types";
import { KernelSize, ToneMappingMode } from "postprocessing";
import * as THREE from "three";

export const VAULT_DATA_SAMPLE: VaultData = {
  id: 0,
  uid: "sample",
  titleLogoUrl: "",
  name: "Vault",
  description: "Guest's default vault",
  type: VAULT_TYPE.MY_PAGE,
  access: VAULT_ACCESS.PUBLIC,
  uploadPolicy: VAULT_UPLOAD_POLICY.ANYONE,
  created: new Date(),
  username: "🙂",
  personalColour: HENGE.MAIN_COLOUR.blue100,
};

export const VAULT_OBJECT_SAMPLES: VaultObjectData[] = [
  {
    id: 0,
    uid: "0",
    type: VAULT_OBJECT_TYPE.OBJECT,
    name: "apple_watch_ultra_2",
    downloadable: false,
    license: LICENSE.CC_BY,
    credit: {
      creator: "polyman Studio",
      url: "https://sketchfab.com/3d-models/apple-watch-ultra-2-f33263c457664b43909200c5ed5e6fa2",
    },
    thumbnailUrl:
      "/assets/models/sample/preview/apple_watch_ultra_2_1760686292674_preview.png",
    thumbnailVersion: "241217",
    thumbnailPosition: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailRotation: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailScale: 0.8,
    filter: {
      name: "Jobs_241217",
      camera: { fov: 30.0, type: "PerspectiveCamera" },
      strength: 1.0,
      turntable: { speed: 0.5, showHengeTile: false },
      background: { hex: "#efefef", type: "Color" },
      lightPreset: {
        name: "Museum",
        factor: 0.6,
        lights: [
          {
            name: "museum-spot-light-01",
            type: "SpotLight",
            angle: 0.7853982,
            color: "#ffffff",
            power: 2.0,
            penumbra: 0.5,
            position: new THREE.Vector3(0.0, -3.0, 0.0),
            intensity: 1.0,
          },
        ],
        environment: {
          files: "studio_small_09_1k.hdr",
          environmentIntensity: 0.2,
        },
      },
      postprocessing: {
        effects: {
          ToneMapping: { mode: ToneMappingMode.CINEON },
          BrightnessContrast: { contrast: 0.1, brightness: 0.05 },
        },
      },
    },
    keywords: "",
    data: JSON.stringify({}),
    tagList: [],
    likes: [],
    comments: [],
    annotations: [
      {
        id: 1,
        position: { x: 0.1117, y: 0.4284, z: 0.2823 },
        camera: {
          position: { x: 0.0131, y: -0.6989, z: 1.5895 },
          target: { x: 0, y: 0.24, z: 0 },
          focalOffset: { x: 0.01, y: -0.3, z: 0 },
          zoom: 1.8823243251782689,
        },
        data: "<p><strong>디스플레이.</strong> 비스듬한 각도에서도 화면을 밝게 볼 수 있게 해주는 와이드 앵글 OLED. 시계 페이스에 매 순간 초침을 표시해도 전력 부담을 없게 하는 뛰어난 전력 효율성의 LTPO3 기술.</p>",
      },
      {
        id: 2,
        position: { x: 0.1652, y: 0.5717, z: 0.0794 },
        camera: {
          position: { x: 1.752, y: 0.0236, z: -0.5703 },
          target: { x: 0, y: 0.24, z: 0 },
          focalOffset: { x: -0.1606, y: -0.1893, z: 0 },
          zoom: 1.8823243251782689,
        },
        data: "<p><strong>내구성.</strong> 탁월한 내구성의 Ultra&nbsp;3. 러기드급 티타늄 케이스 및 가장 단단한 천연재료 중 하나인 사파이어 크리스털로 제작된 디스플레이 탑재.</p>",
      },
      {
        id: 3,
        position: { x: -0.1985, y: 0.4098, z: 0.226 },
        camera: {
          position: { x: -2.5079, y: 0.6897, z: 0.3072 },
          target: { x: 0, y: 0.24, z: 0 },
          focalOffset: { x: -0.0174, y: -0.1219, z: 0 },
          zoom: 1.8823243251782689,
        },
        data: "<p><strong>동작 버튼.</strong> 짧게 한 번 누르는 것만으로 운동 시작, 구간 표시, 손전등 실행 등 다양한 맞춤 설정 기능을 정교하게 물리적으로 제어 가능.</p>",
      },
      {
        id: 4,
        position: { x: -0.0114, y: 0.2368, z: -0.3171 },
        camera: {
          position: { x: 1.8257, y: -2.1696, z: -1.1558 },
          target: { x: 0, y: 0.24, z: 0 },
          focalOffset: { x: 0.1133, y: 0.0024, z: 0 },
          zoom: 1.8823243251782689,
        },
        data: "<p><strong>밴드.</strong> Ultra&nbsp;3의 아름다우면서 끝없이 다재다능한 4가지 밴드 스타일. 운동부터 야간 활동까지 일상에 어울리는 다채로운 매력 발산.</p>",
      },
    ],
    vaultData: VAULT_DATA_SAMPLE,
    assetData: {
      id: 0,
      uid: "0",
      extension: "glb",
      url: "/assets/models/sample/apple_watch_ultra_2.glb",
      signedUrl: "/assets/models/sample/apple_watch_ultra_2.glb",
      created: new Date(),
      fileList: [
        {
          name: "0",
          contentType: "model/gltf-binary",
          extension: "glb",
          url: "/assets/models/sample/apple_watch_ultra_2.glb",
          signedUrl: "/assets/models/sample/apple_watch_ultra_2.glb",
          bytes: 1936,
          created: new Date(),
        },
      ],
    },
  },
  {
    id: 1,
    uid: "1",
    type: VAULT_OBJECT_TYPE.OBJECT,
    name: "cc0____japanese_freshwater_crab",
    downloadable: false,
    license: LICENSE.CC0,
    credit: {
      creator: "ffish.asia / floraZia.com",
      url: "https://sketchfab.com/3d-models/cc0-japanese-freshwater-crab-35559c2236d04c1a80ccbe08cae863c6",
    },
    thumbnailUrl:
      "/assets/models/sample/preview/cc0____japanese_freshwater_crab_1760686027700_preview.png",
    thumbnailVersion: "241217",
    thumbnailPosition: { x: 0.0, y: -0.06, z: 0.0 },
    thumbnailRotation: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailScale: 0.8,
    filter: {
      name: "Nolan_241217",
      camera: { fov: 90.0, type: "PerspectiveCamera" },
      strength: 0.5,
      turntable: { speed: 0.0, showHengeTile: false },
      background: { hex: "#56798e", type: "Color" },
      lightPreset: {
        name: "Outdoor",
        factor: 0.5,
        lights: [
          {
            name: "outdoor-ambient-light-01",
            type: "AmbientLight",
            color: "#ffffff",
            intensity: 2.0,
          },
          {
            name: "outdoor-directional-light-01",
            type: "DirectionalLight",
            color: "#ffffff",
            position: new THREE.Vector3(3.0, 5.0, 0.0),
            intensity: 2.0,
          },
        ],
        environment: { files: "outdoor_3_1k.jpg", environmentIntensity: 1.0 },
      },
      postprocessing: {
        effects: {
          LUT: { name: "The-Batman.cube" },
          ToneMapping: { mode: ToneMappingMode.CINEON },
          BrightnessContrast: { contrast: 0.3, brightness: 0.0 },
        },
      },
    },
    keywords: "",
    data: JSON.stringify({}),
    tagList: [],
    likes: [],
    comments: [],
    annotations: [],
    vaultData: VAULT_DATA_SAMPLE,
    assetData: {
      id: 1,
      uid: "1",
      extension: "glb",
      url: "/assets/models/sample/cc0____japanese_freshwater_crab.glb",
      signedUrl: "/assets/models/sample/cc0____japanese_freshwater_crab.glb",
      created: new Date(),
      fileList: [
        {
          name: "1",
          contentType: "model/gltf-binary",
          extension: "glb",
          url: "/assets/models/sample/cc0____japanese_freshwater_crab.glb",
          signedUrl:
            "/assets/models/sample/cc0____japanese_freshwater_crab.glb",
          bytes: 3420664,
          created: new Date(),
        },
      ],
    },
  },
  {
    id: 2,
    uid: "2",
    type: VAULT_OBJECT_TYPE.OBJECT,
    name: "cc0____japanese_rhinoceros_beetle_red",
    downloadable: false,
    license: LICENSE.CC0,
    credit: {
      creator: "ffish.asia / floraZia.com",
      url: "https://sketchfab.com/3d-models/cc0-japanese-rhinoceros-beetle-red-5ab766d125cd4e4d943e8907a262a3a7",
    },
    thumbnailUrl:
      "/assets/models/sample/preview/cc0____japanese_rhinoceros_beetle_red_1760686251994_preview.png",
    thumbnailVersion: "241217",
    thumbnailPosition: { x: 0.0, y: -0.02, z: 0.0 },
    thumbnailRotation: { x: -3.1415927, y: -0.5235988, z: -3.1415927 },
    thumbnailScale: 0.8,
    filter: {
      name: "Nolan_241217",
      camera: { fov: 90.0, type: "PerspectiveCamera" },
      strength: 1.0,
      turntable: { speed: 0.0, showHengeTile: false },
      background: { hex: "#303c30", type: "Color" },
      lightPreset: {
        name: "Outdoor",
        factor: 0.5,
        lights: [
          {
            name: "outdoor-ambient-light-01",
            type: "AmbientLight",
            color: "#ffffff",
            intensity: 2.0,
          },
          {
            name: "outdoor-directional-light-01",
            type: "DirectionalLight",
            color: "#ffffff",
            position: new THREE.Vector3(3.0, 5.0, 0.0),
            intensity: 2.0,
          },
        ],
        environment: { files: "outdoor_3_1k.jpg", environmentIntensity: 1.0 },
      },
      postprocessing: {
        effects: {
          LUT: { name: "The-Batman.cube" },
          ToneMapping: { mode: ToneMappingMode.CINEON },
          BrightnessContrast: { contrast: 0.3, brightness: 0.0 },
        },
      },
    },
    keywords: "",
    data: JSON.stringify({}),
    tagList: [],
    likes: [],
    comments: [],
    annotations: [],
    vaultData: VAULT_DATA_SAMPLE,
    assetData: {
      id: 2,
      uid: "2",
      extension: "glb",
      url: "/assets/models/sample/cc0____japanese_rhinoceros_beetle_red.glb",
      signedUrl:
        "/assets/models/sample/cc0____japanese_rhinoceros_beetle_red.glb",
      created: new Date(),
      fileList: [
        {
          name: "2",
          contentType: "model/gltf-binary",
          extension: "glb",
          url: "/assets/models/sample/cc0____japanese_rhinoceros_beetle_red.glb",
          signedUrl:
            "/assets/models/sample/cc0____japanese_rhinoceros_beetle_red.glb",
          bytes: 4003720,
          created: new Date(),
        },
      ],
    },
  },
  {
    id: 3,
    uid: "3",
    type: VAULT_OBJECT_TYPE.OBJECT,
    name: "cc0__japanese_silver_tree_n_sericea",
    downloadable: false,
    license: LICENSE.CC0,
    credit: {
      creator: "ffish.asia / floraZia.com",
      url: "https://sketchfab.com/3d-models/cc0-japanese-silver-tree-n-sericea-d9e174d623124d2aa23122683018f6e6",
    },
    thumbnailUrl:
      "/assets/models/sample/preview/cc0__japanese_silver_tree_n_sericea_1760686996526_preview.png",
    thumbnailVersion: "241217",
    thumbnailPosition: { x: 0.0, y: -0.045, z: 0.0 },
    thumbnailRotation: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailScale: 0.8,
    filter: {
      name: "Default_241217",
      camera: { fov: 1.0, type: "PerspectiveCamera" },
      strength: 0.2,
      turntable: { speed: 0.0, showHengeTile: false },
      background: { hex: "#ffd9a3", type: "Color" },
      lightPreset: {
        name: "Studio",
        factor: 0.5,
        lights: [
          {
            name: "default-ambient-light-01",
            type: "AmbientLight",
            color: "#ffffff",
            intensity: 0.04,
          },
          {
            name: "default-directional-light-01",
            type: "DirectionalLight",
            color: "#ffffff",
            position: new THREE.Vector3(0.0, 5.0, 0.0),
            intensity: 1.9,
          },
        ],
        environment: {
          files: "studio_small_09_1k.hdr",
          environmentIntensity: 0.5,
        },
      },
      postprocessing: {
        effects: { ToneMapping: { mode: ToneMappingMode.AGX } },
      },
    },
    keywords: "",
    data: JSON.stringify({}),
    tagList: [],
    likes: [],
    comments: [],
    annotations: [],
    vaultData: VAULT_DATA_SAMPLE,
    assetData: {
      id: 3,
      uid: "3",
      extension: "glb",
      url: "/assets/models/sample/cc0__japanese_silver_tree_n._sericea.glb",
      signedUrl:
        "/assets/models/sample/cc0__japanese_silver_tree_n._sericea.glb",
      created: new Date(),
      fileList: [
        {
          name: "3",
          contentType: "model/gltf-binary",
          extension: "glb",
          url: "/assets/models/sample/cc0__japanese_silver_tree_n._sericea.glb",
          signedUrl:
            "/assets/models/sample/cc0__japanese_silver_tree_n._sericea.glb",
          bytes: 21609708,
          created: new Date(),
        },
      ],
    },
  },
  {
    id: 4,
    uid: "4",
    type: VAULT_OBJECT_TYPE.OBJECT,
    name: "need_some_space",
    downloadable: false,
    license: LICENSE.CC_BY,
    credit: {
      creator: "Loïc Norgeot",
      url: "https://sketchfab.com/3d-models/need-some-space-d6521362b37b48e3a82bce4911409303",
    },
    thumbnailUrl:
      "/assets/models/sample/preview/need_some_space_1760689987863_preview.png",
    thumbnailVersion: "241217",
    thumbnailPosition: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailRotation: { x: 0.0, y: -1.0471976, z: 0.0 },
    thumbnailScale: 1.5,
    filter: {
      name: "Default_241217",
      camera: { fov: 150.0, type: "PerspectiveCamera" },
      strength: 1.0,
      turntable: { speed: 0.0, showHengeTile: false },
      background: { hex: "#050911", type: "Color" },
      lightPreset: {
        name: "Studio",
        factor: 0.5,
        lights: [
          {
            name: "default-ambient-light-01",
            type: "AmbientLight",
            color: "#ffffff",
            intensity: 0.04,
          },
          {
            name: "default-directional-light-01",
            type: "DirectionalLight",
            color: "#ffffff",
            position: new THREE.Vector3(0.0, 5.0, 0.0),
            intensity: 1.9,
          },
        ],
        environment: {
          files: "studio_small_09_1k.hdr",
          environmentIntensity: 0.5,
        },
      },
      postprocessing: {
        effects: {
          ToneMapping: { mode: ToneMappingMode.AGX },
          Bloom: {
            intensity: 2.0,
            kernelSize: KernelSize.HUGE,
            // blendFunction: BlendFunction.AVERAGE,
            luminanceThreshold: 0.1,
            luminanceSmoothing: 0.0,
            mipmapBlur: false,
          },
        },
      },
    },
    keywords: "",
    data: JSON.stringify({}),
    tagList: [],
    likes: [],
    comments: [],
    annotations: [],
    vaultData: VAULT_DATA_SAMPLE,
    assetData: {
      id: 4,
      uid: "4",
      extension: "glb",
      url: "/assets/models/sample/need_some_space.glb",
      signedUrl: "/assets/models/sample/need_some_space.glb",
      created: new Date(),
      fileList: [
        {
          name: "4",
          contentType: "model/gltf-binary",
          extension: "glb",
          url: "/assets/models/sample/need_some_space.glb",
          signedUrl: "/assets/models/sample/need_some_space.glb",
          bytes: 1401564,
          created: new Date(),
        },
      ],
    },
  },
  {
    id: 5,
    uid: "5",
    type: VAULT_OBJECT_TYPE.OBJECT,
    name: "tinylivingpack",
    downloadable: false,
    license: LICENSE.CC_BY,
    credit: {
      creator: "Vlad",
      url: "https://sketchfab.com/3d-models/tinylivingpack-e192841259554d1cabb08c7a8180be9f",
    },
    thumbnailUrl:
      "/assets/models/sample/preview/tinylivingpack_1760691201441_preview.png",
    thumbnailVersion: "241217",
    thumbnailPosition: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailRotation: { x: 0.0, y: 0.0, z: 0.0 },
    thumbnailScale: 1.0,
    filter: {
      name: "Default_241217",
      camera: { fov: 1.0, type: "PerspectiveCamera" },
      strength: 0.5,
      turntable: { speed: 0.0, showHengeTile: false },
      background: { hex: "#cadfd1", type: "Color" },
      lightPreset: {
        name: "Studio",
        factor: 0.5,
        lights: [
          {
            name: "default-ambient-light-01",
            type: "AmbientLight",
            color: "#ffffff",
            intensity: 0.04,
          },
          {
            name: "default-directional-light-01",
            type: "DirectionalLight",
            color: "#ffffff",
            position: new THREE.Vector3(0.0, 5.0, 0.0),
            intensity: 2.242,
          },
        ],
        environment: {
          files: "studio_small_09_1k.hdr",
          environmentIntensity: 0.5,
        },
      },
      postprocessing: {
        effects: { ToneMapping: { mode: ToneMappingMode.AGX } },
      },
    },
    keywords: "",
    data: JSON.stringify({}),
    tagList: [],
    likes: [],
    comments: [],
    annotations: [
      {
        id: 1,
        position: { x: 0.1442, y: 0.1805, z: -0.0105 },
        camera: {
          position: { x: 24.5835, y: 8.0243, z: -23.3036 },
          target: { x: 0, y: 0.24, z: 0 },
          focalOffset: { x: -0.0524, y: 0.0965, z: 0 },
          zoom: 4.2975,
        },
        data: "<h1><strong>HEKTAR 헥타르</strong></h1><p>펜던트등, 다크그레이, 22cm</p><p><strong>￦29,900</strong></p><p><strong><em>Link: </em></strong><br>https://www.ikea.com/kr/ko/p/hektar-pendant-lamp-dark-grey-40390375/</p>",
      },
      {
        id: 2,
        position: { x: -0.1105, y: 0.0436, z: 0.1077 },
        camera: {
          position: { x: 27.4478, y: 9.8931, z: 22.5723 },
          target: { x: 0, y: 0, z: 0 },
          focalOffset: { x: -0.1734, y: -0.0414, z: 0 },
          zoom: 4.2975,
        },
        data: "<h1><strong>SAGESUND 사게순드</strong></h1><p>쿠션형 침대프레임, 디세뢰드 브라운/뢴세트, 90x200 cm</p><p><strong>￦434,000</strong></p><p><strong><em>Link: </em></strong><br>https://www.ikea.com/kr/ko/p/sagesund-upholstered-bed-frame-diseroed-brown-loenset-s69496507/</p>",
      },
      {
        id: 3,
        position: { x: 0.1917, y: 0.04686, z: 0.0211 },
        camera: {
          position: { x: 19.5277, y: 10.4866, z: 20.6743 },
          target: { x: 0, y: 0.0809, z: 0 },
          focalOffset: { x: 0.0717, y: 0.0858, z: 0 },
          zoom: 4.2975,
        },
        data: "<h1><strong>VEDBO 베드보</strong></h1><p>하이백암체어, 군나레드 라이트그린</p><p><strong>￦299,000</strong></p><p><strong><em>Link: </em></strong><br>https://www.ikea.com/kr/ko/p/vedbo-high-back-armchair-gunnared-light-green-10494261/</p>",
      },
      {
        id: 4,
        position: { x: -0.1846, y: 0.1053, z: -0.0003 },
        camera: {
          position: { x: 23.8408, y: 23.0794, z: -4.5036 },
          target: { x: 0, y: 0.24, z: 0 },
          focalOffset: { x: 0.0835, y: -0.0025, z: 0 },
          zoom: 4.2975,
        },
        data: "<h1><strong>TONSTAD 톤스타드</strong></h1><p>도어수납장, 참나무무늬목, 82x47x90 cm</p><p><strong>￦299,000</strong></p><p><strong><em>Link: </em></strong><br>https://www.ikea.com/kr/ko/p/tonstad-cabinet-with-doors-oak-veneer-60489238/</p>",
      },
    ],
    vaultData: VAULT_DATA_SAMPLE,
    assetData: {
      id: 5,
      uid: "5",
      extension: "glb",
      url: "/assets/models/sample/tinylivingpack.glb",
      signedUrl: "/assets/models/sample/tinylivingpack.glb",
      created: new Date(),
      fileList: [
        {
          name: "5",
          contentType: "model/gltf-binary",
          extension: "glb",
          url: "/assets/models/sample/tinylivingpack.glb",
          signedUrl: "/assets/models/sample/tinylivingpack.glb",
          bytes: 5968840,
          created: new Date(),
        },
      ],
    },
  },
];
